// eslint-disable-next-line import/prefer-default-export
export const GET_SERVICIO_ID = 'GET_SERVICIO_ID';
export const UPDATE_SERVICIO_ID = 'UPDATE_SERVICIO_ID';